import type { ParentComponent } from 'solid-js'
import { css } from 'styled-system/css'
import { Grid, type GridProps } from 'styled-system/jsx'

export const Layout: ParentComponent<GridProps> = (props) => {
	const { children, ...rest } = props

	return (
		<Grid
			class={css({
				p: '3',
				gap: '3',
			})}
			{...rest}
		>
			{props.children}
		</Grid>
	)
}
